import { useReducer } from 'react'

/** Manually re-render a component. */
export function useReRender() {
    return useReducer(() => ({}), {})[1]
}
